module.exports = __webpack_public_path__ + "img/e277c02.png";